module.exports = __webpack_public_path__ + "static/media/head-icon.289a89a2.svg";